import React from "react";
import "./App.scss";
import { Navigation } from "./components/Navigation";
import { Intro } from "./components/Intro";
import { About } from "./components/About";
import { Skills } from "./components/Skills";
import { Footer } from "./components/Footer";
import { Social } from "./components/Social";
import { MyWork } from "./components/MyWork";

function App() {
  return (
    <div className="mainContainer">
      <Navigation />
      <Social />
      <Intro />
      <About />
      <Skills />
      <MyWork />
      <Footer />
    </div>
  );
}

export default App;
